<script>
import { sync } from 'vuex-pathify'

export default {
	lang: 'shop',
	props: {
		product: Object,
		variant: Object,
		ctaText: String,
		customization: Object,
		qtyInputClass: String,
	},
	data() {
		return {
			qty: 1,
			hideStockQtyMessage: this.$srv('shopOptions')?.hideStockQtyMessage,
		}
	},
	computed: {
		ctaIsLoading: sync('shop/ctaIsLoading'),
		outOfStock() {
			return this.variant.stock.availability == 'OutOfStock'
		},
		maxStockQty() {
			let { maxBuyableQty, infiniteQty, qty } = this.variant.stock
			if (maxBuyableQty >= 1) {
				if (infiniteQty) return maxBuyableQty
				else return Math.min(qty, maxBuyableQty)
			} else {
				if (infiniteQty) return 0
				else return qty
			}
		},
	},
	eventsListeners: {
		buyProduct() {
			this.ctaClicked()
		},
	},
	methods: {
		async ctaClicked() {
			return this.$shop.addToCart({
				productId: this.product.id,
				variantId: this.variant.id,
				qty: this.qty,
				sum: true,
				customization: this.customization,
				loading: (v) => (this.ctaIsLoading = v),
				onValidation: ({ validation }) => this.$emit('validation', validation),
			})
		},
	},
}
</script>

<template>
	<div>
		<QtyInput
			v-if="variant.type == 'physical' && !outOfStock && product.buyable"
			v-model="qty"
			:max-qty="maxStockQty"
			:unit-metric="product.unitMetric"
			:pack-metric="product.packMetric"
			:step="variant.metricFactor"
			:class="qtyInputClass"
		/>
		<ProductStockQtyMessage
			v-if="!hideStockQtyMessage && variant.type == 'physical' && product.buyable"
			:stock="variant.stock"
			:metric="product.unitMetric"
			class="pt-2 grey--text"
			style="font-size: 0.9rem"
		/>
		<div class="pt-4">
			<Button
				class="full-width py-5 btn-buy"
				color="cta"
				:disabled="outOfStock || !product.buyable"
				:loading="ctaIsLoading"
				@click="ctaClicked"
				large
			>
				<v-icon class="font-0 mr-2">mdi-cart-outline</v-icon>
				<span class="font-2">{{ ctaText || $lang('Comprar ahora') }}</span>
			</Button>
		</div>
	</div>
</template>
